module.exports = __webpack_public_path__ + "static/media/muravidekre_logo_2.3c4bdee8.jpg";